/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as n from "react";
import r from "prop-types";
const s = class s extends n.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
s.propTypes = {
  text: r.string,
  url: r.string,
  icon: r.string,
  disabled: r.bool,
  cssClass: r.string,
  cssStyle: r.object,
  render: r.any,
  linkRender: r.any,
  contentRender: r.any,
  data: r.any,
  separator: r.bool
};
let t = s;
export {
  t as MenuItem
};
